import { useDispatch, useSelector } from 'react-redux';
import { GoogleMap, useJsApiLoader, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';
import { getCMSAssets, getGoogleMapAPIKey, getImageFileNameByID2 } from 'helpers/Uri';
import { Dialog } from 'primereact/dialog';
import React, { useState, useEffect } from 'react'
import { Button, Col, Row } from 'react-bootstrap';
import { isNil } from 'lodash';
import { classNames } from 'primereact/utils';
import { IAppState } from 'model/IAppState';
import * as scheduleDeliveryModel from 'model/IOrderScheduleDelivery';
import * as rdEnum from 'helpers/enum';
import PickupLocation from './PickupLocation';
import * as orderModel from 'model/IOrder';

import moment from 'moment';

const ViewAppointment = (props: any) => {
    const { buttonText } = props;


    const [dialogVisible, setDialogVisible] = useState(false);

    const orderScheduleDeliveryFromStore: scheduleDeliveryModel.IOrderScheduleDelivery = useSelector((state: IAppState) => {
        return state?.orderScheduleDelivery;
    });

    const orderDetailsFromStore: orderModel.IOrderRequest | null = useSelector((state: IAppState) => {
        return state?.orderDetails;
    });


    const onShowDialog = () => {
        setDialogVisible(true);
    }

    const onHideDialog = () => {
        setDialogVisible(false);
    }



    return (
        <>
            <div className='pipeline-btn-panel'>
                <Button className='pipeline-btn'
                    onClick={() => onShowDialog()}
                >
                    <h6>{buttonText}</h6>
                </Button>
            </div>

            <Dialog
                className='order-details-dialog view-appointment-dialog'
                visible={dialogVisible} position='bottom'
                style={{ minWidth: '40% !important' }} draggable={false}
                resizable={true}
                onHide={() => onHideDialog()}
            >
                <div className='view-appointment-dialog-container'>
                    <Row>
                        <Col className="container-title">YOUR DELIVERY</Col>
                    </Row>
                    <Row>
                        <Col className="desc">Delivery of your Cadillac is fast approaching. Please remember full payment for your vehicle is required 3 business days prior to your delivery appointment.</Col>
                    </Row>
                    <Row>
                        <Col md={6} xs={12} className="view-appointment-wrapper">
                            <div className='view-appointment-section'>
                                <div className='section-title'>APPOINTMENT</div>

                                <div className='view-appointment-item'>
                                    <div className="title">Date</div>
                                    <div className="data">{moment(orderScheduleDeliveryFromStore?.DeliveryDate).format("dddd, DD MMMM YYYY")}</div>
                                </div>
                                <div className='view-appointment-item'>
                                    <div className="title">Time</div>
                                    <div className="data">{orderScheduleDeliveryFromStore?.DeliveryTime}</div>
                                </div>
                                <div className='view-appointment-item'>
                                    {orderScheduleDeliveryFromStore?.DeliveryOption === rdEnum.enumDeliveryOptions.Pickup ? (
                                        <>
                                            <div className="title">{orderScheduleDeliveryFromStore?.PickupLocationName}</div>
                                            <div className="data">{orderScheduleDeliveryFromStore?.DeliveryLocationAddress}</div>
                                        </>
                                    )
                                        :
                                        (
                                            <>
                                                <div className="title">Delivery Location</div>
                                                <div className="data">{orderScheduleDeliveryFromStore?.DeliveryLocationAddress}</div>
                                            </>
                                        )
                                    }
                                </div>
                            </div>
                        </Col>
                        <Col md={6} xs={12} className="view-appointment-wrapper">
                            <div className='view-appointment-section'>
                                <div className='section-title'>GET SUPPORT</div>
                                <div className='section-desc'>We're here to help every step of the way. Please contact your Cadillac Sales Ambassador if you need support arranging your payment.</div>
                                <div className='view-appointment-item'>
                                    {
                                        orderDetailsFromStore?.Country === rdEnum.enumCountryCode.NewZealand ? (
                                            <div className='view-appointment-item'>
                                                <div className="title">Cadillac New Zealand</div>
                                                <div className="data">0800 223 455</div>
                                            </div>
                                        ) : (
                                                <div className='view-appointment-item'>
                                                    <div className="title">Cadillac Australia</div>
                                                    <div className="data">1800 223 455</div>
                                                </div>
                                            )
                                    }


                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Dialog>
        </>
    )
}

export default ViewAppointment